module.exports = __webpack_public_path__ + "img/video.fd33ceb2.svg";